/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    outline: { type: 'variant', values: [ true ] },
    purpose: { type: 'variant', values: [ 'offer', 'editorial', 'subtle' ] },
    size: { type: 'variant', values: [ 'compact' ] }
  },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffffff',
        color: '#ffffff'
      }
    },
    {
      if: { outline: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: '#a1ed00' }
    },
    {
      if: { alternative: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#dd0066',
        color: '#dd0066',
        fontSize: 16,
        paddingBottom: 8,
        paddingTop: 8
      }
    },
    {
      if: { purpose: 'offer' },
      tokens: {
        backgroundColor: '#7a3dfc',
        color: '#ffffff',
        fontSize: 16,
        paddingBottom: 8,
        paddingTop: 8
      }
    },
    {
      if: { purpose: 'editorial' },
      tokens: { backgroundColor: '#ffad00', color: '#000000', fontSize: 16 }
    },
    {
      if: { purpose: 'subtle' },
      tokens: {
        backgroundColor: '#e0d8fc',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#000000'
      }
    },
    {
      if: { outline: true, purpose: 'subtle' },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: '#e0d8fc' }
    },
    {
      if: { outline: true, purpose: 'editorial' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffad00',
        color: '#000000'
      }
    },
    {
      if: { outline: true, purpose: 'offer' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#7a3dfc',
        color: '#000000'
      }
    },
    {
      if: { size: 'compact' },
      tokens: {
        fontSize: 14,
        paddingBottom: 0,
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 0
      }
    }
  ],
  tokens: {
    backgroundColor: '#a1ed00',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    borderWidth: 2,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 14,
    fontWeight: '600',
    gradient: null,
    paddingBottom: 2,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 2
  }
}
export default theme
